import React from 'react'
import { Outlet } from 'react-router'
import { useAuthContext } from '@/providers/Global'

import { LayoutIndexLoggedIn } from './Index.loggedIn'

const LayoutIndexInternal: React.FC = () => {
  const Auth = useAuthContext()

  if (!Auth.active) {
    return <Outlet />
  }

  return <LayoutIndexLoggedIn />
}

export const LayoutIndex = React.memo(LayoutIndexInternal) as typeof LayoutIndexInternal
